import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  markReadNotification,
} from "../../redux/slices/personalDashboardSlice";

export default function NotificationCard({ notification }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isCompany = pathname.includes("company_dashboard");
  const dashboardRoot = isCompany ? "/company_dashboard" : "/personal_dashboard";

  const normalizeType = (type = "") =>
  type
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toLowerCase();

  const goToLink = (e) => {
    e.stopPropagation();

    // 1. Special redirect for Monthly Data Reminder
    if (notification.notification_type === "monthly_data_reminder") {
      navigate(
        `/company_dashboard/services/service_report/${notification.notifiable_id}?manageDataModal=true`
      );
      dispatch(markReadNotification(notification.id));
      return;
    }

    // 2. Default redirect logic
    let actionPath = notification.action_url || "";

    // 3. Normal redirect (Requests etc.)
    navigate(`${dashboardRoot}${actionPath}`, {
      state: {
        openPopup: true,
        locationSetId: {
          id: notification.notifiable_id,
          userId: notification.user_id
        }
      }
    });
    dispatch(markReadNotification(notification.id));
  };

  const isUnread = !notification.is_read;

  return (
    <div className="w-full bg-[#242B3E] lg:min-h-[160px] border border-[#3A4255] rounded-2xl p-3 md:p-5 gap-3 lg:gap-0 flex flex-col lg:flex-row justify-between items-start hover:brightness-110 transition-all">
      
      {/* LEFT SIDE */}
      <div className="flex-1 pr-4">
        <div className="flex items-start space-x-3">
          
          {/* Unread dot */}
          {isUnread && (
            <div className="w-2 h-2 rounded-full bg-blue-500"></div>
          )}
          <h3
            className={` text-sm leading-5 text-white min-h-[30px] ${
              isUnread ? "font-semibold" : "font-medium"
            }`}
          >
            {notification.title}
          </h3>
        </div>

        {/* Message */}
        <p
          className={`text-sm mt-3 ${
            isUnread ? "text-gray-200" : "text-gray-400"
          }`}
        >
          {notification.message}
        </p>

        {/* Time */}
        <p className="text-xs text-gray-500 mt-2">
          {new Date(notification.created_at).toLocaleString()}
        </p>
      </div>

      {/* Right "View" button */}
      {notification.action_url && (
        <button
          onClick={goToLink}
          className="text-sm bg-yellow-400 hover:bg-yellow-500 text-black px-4 py-1.5 rounded-md font-medium"
        >
          {
            notification.notification_type === "monthly_data_reminder"
              ? "Upload data"
              : `View ${normalizeType(notification.notifiable_type)}`
          } 
        </button>
      )}
    </div>
  );
}
